import {useAuthContext} from 'geestack-toolbox';
import {IUser} from '../hooks/apis/useUser';

export default function useAuth() {
  return useAuthContext<IUser>();
}
